module.exports = __webpack_public_path__ + "img/secondary_3x2_z18.53fe4acd.svg";